import * as React from "react";
import GenericSettingsScreen from "../GenericSettingsScreen";
import { AppList, AppListItem } from "../Generic/AppList";
import TrailingChevron from "../Generic/TrailingChevron/TrailingChevron";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

interface CaseSettingsV2ScreenProps {
  showMyStaffingPreferencesOption: boolean;
  onClickGoBack: () => void;
  onClickMyAvailability: () => void;
  onClickMyStaffingPreferences: () => void;
}

const CaseSettingsV2Screen = (props: CaseSettingsV2ScreenProps) => {
  return (
    <GenericSettingsScreen
      title={translate(STRINGS.CASE_SETTINGS)}
      onClickGoBack={props.onClickGoBack}
    >
      <AppList bordered={true}>
        <AppListItem
          title={translate(STRINGS.MY_AVAILABILITY)}
          trailing={<TrailingChevron />}
          onClick={props.onClickMyAvailability}
        />
        {props.showMyStaffingPreferencesOption ? (
          <AppListItem
            title={translate(STRINGS.MY_STAFFING_PREFERENCES)}
            trailing={<TrailingChevron />}
            onClick={props.onClickMyStaffingPreferences}
          />
        ) : null}
      </AppList>
    </GenericSettingsScreen>
  );
};

export default CaseSettingsV2Screen;
